module.exports = __webpack_public_path__ + "img/94.1.8fa740b4.jpg";